import * as React from "react";
export function SvgSchemaViewerGeoContinuous(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={17} {...props}>
      <path
        d="M16 6h-2.2c-.4-1.8-1.3-3-2.2-3S9.7 4.2 9.2 6H7v1h2.1c-.1.5-.2 1-.2 1.5s.1 1 .2 1.5H7v1h2.2c.4 1.8 1.3 2.9 2.3 2.9s1.8-1.2 2.3-2.9H16v-1h-2.1c.1-.5.1-1 .1-1.5s0-1-.1-1.5H16V6zm-4.5-2.1c.5 0 1 .9 1.3 2.1h-2.6c.3-1.2.8-2.1 1.3-2.1zm0 9.2c-.5 0-1-.9-1.3-2.1h2.6c-.3 1.3-.8 2.1-1.3 2.1zm1.6-4.6c0 .5 0 1-.1 1.5h-3c0-.5-.1-1-.1-1.5s0-1 .1-1.5h2.9c.1.5.2 1 .2 1.5z"
        fill="#53bd92"
      />
      <path
        d="M11.5 3C8.5 3 6 5.5 6 8.5S8.5 14 11.5 14 17 11.5 17 8.5 14.5 3 11.5 3zm0 10C9 13 7 11 7 8.5S9 4 11.5 4 16 6 16 8.5 14 13 11.5 13z"
        fill="#47a67f"
      />
    </svg>
  );
}
